import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { from, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ProgressStageData, ProgressStagesEnum, ProgressSteps } from 'src/app/shared/components/progress-bar/progress.values';
import { UserAdminVerificationStatusEnum } from 'src/app/users/interfaces/user-values';
import { IUser, IUserMetadata } from 'src/app/users/interfaces/user.interface';
import { UserService } from 'src/app/users/services/user.service';

interface LevelData extends ProgressStageData {
  current: boolean;
  done: boolean;
}

@Component({
  selector: 'score-board',
  templateUrl: './score-board.component.html',
  styleUrls: ['./score-board.component.scss'],
})

export class ScoreBoardComponent implements OnInit {
  userScore$: Observable<number>;
  levelsData: LevelData[];
  allUsersMeta: IUserMetadata[] = [];
  isLoading = false;
  private lang: string;

  constructor(private userService: UserService, private activeModal: NgbActiveModal) {}

  isScoreShown = true;

  ngOnInit(): void {
    this.userScore$ = this.getUserScore();
  }

  closeModal(): void {
    this.activeModal.close();
  }

  levelsTrackBy(index: number, level: LevelData): ProgressStagesEnum {
    return level.stage;
  }

  setScoreActive(val: boolean): void {
    this.isScoreShown = val;
    if (!val) {
      this.getAllUsersProgress();
    }
  }

  private getUserScore(): Observable<number> {
    return from(this.userService.getCurrentUserDetails()).pipe(
      map((user: IUser) => user?.metadata?.progress?.numOfCompleted ?? 0),
      tap((score: number) => this.constructLevelsData(score))
    );
  }

  private constructLevelsData(score: number): void {
    this.levelsData = ProgressSteps.map((level, i, arr) => ({
      ...level,
      current: score < level.numLect && (i === 0 || score >= arr[i - 1].numLect),
      done: score >= level.numLect,
    }));
  }

  private async getAllUsersProgress(): Promise<void> {
    if (this.allUsersMeta?.length === 0) {
      this.isLoading = true;
      this.allUsersMeta = await this.userService.getAllUsersByFilter((ref) =>
        ref.where('adminVerificationStatus', '==', UserAdminVerificationStatusEnum.APPROVED), true);
      this.allUsersMeta.sort((a, b) => (a.progress?.numOfCompleted < b.progress?.numOfCompleted) ?
        1 : ((b.progress?.numOfCompleted < a.progress?.numOfCompleted) ? -1 : 0));
      this.isLoading = false;
    }
  }
}
